<template>
  <div class="reply_main">
    <head-top head-title="论坛评论区" go-back="true"></head-top>
    <div class="descript">
      <avatar class="avt" :list="list"></avatar>
      <desc-pic :list="list"></desc-pic>
      <div class="read_number">
        <span>阅读量：{{list.reading_amount}}</span>
      </div>
    </div>
    <section class="reply-wrapper">
      <comment :list="list" :lists="lists" @passMethods="_getReply" v-if="flag"></comment>
    </section>
  </div>
</template>

<script>
  import headTop from '../header/Header.vue'
  import comment from '../common/comment.vue'
  import avatar from '../common/avatar.vue'
  import descPic from '../common/desPic.vue'
  import { getReply } from '../../api/message.js'

  export default {
    name: 'Reply',
    data () {
      return {
        lists: [],
        list: {},
        flag: false
      }
    },
    components: {
      headTop,
      comment,
      avatar,
      descPic
    },
    mounted () {
      this._getReply()
    },
    methods: {
      _getReply () {
        getReply(this.$route.params.id).then(res => {
          if (res.code === 200) {
            this.lists = res.data.comment
            this.list = res.data.house
            this.flag = true
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "../../common/sass/index.scss";

  .reply_main {
    background-color: #fff;
    .descript {
      padding-top: 40px;
      border-bottom: 10px solid #f2f2f2;
      .read_number {
        width: 100%;
        height: 30px;
        text-align: right;
        border-top: 1px solid #f2f2f2;
        span {
          line-height: 30px;
          font-size: 13px;
          margin-right: 10px;
          color: #777777;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/message/Reply.vue